import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c79657b8")

_pushScopeId("data-v-c79657b8")
const _hoisted_1 = { class: "testimonial-wrapper" }
const _hoisted_2 = { class: "testimonial" }
const _hoisted_3 = { class: "testimonial__title" }
const _hoisted_4 = { class: "testimonial__name" }
const _hoisted_5 = { class: "testimonial__content" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("img", {
        src: _ctx.icon,
        class: "testimonial__icon"
      }, null, 8, ["src"]),
      _createVNode("div", _hoisted_3, [
        _createVNode("span", _hoisted_4, _toDisplayString(_ctx.name), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.suffix), 1 /* TEXT */)
      ]),
      _createVNode("p", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ]))
})